<template>
    <div class="flex flex-row mb-4">
        <div class="relative">
            <select id="type" name="type" v-model="type"
                class="appearance-none h-full rounded-l border block appearance-none w-full bg-white border-gray-400 text-gray-700 py-2 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                <option value=0>---</option>
                <option value="add_to_client">{{ $t('Add to Client') }}</option>
                <option value="add_parent_event">{{ $t('Add To Parent event') }}</option>
                <option v-if="$attrs.categories" value="add_categories">{{ $t('Add Categories') }}</option>
                <option v-if="$attrs.locations" value="add_locations">{{ $t('Add Locations') }}</option>
                <option value="force_update_to_client">{{ $t('Force Update to Client') }}</option>
            </select>
        </div>
        <div class="relative">
            <search_select v-if="type == 'add_parent_event'" id="value_to_event" :options="JSON.parse($attrs.events)" :closeOnSelect="false"
                :multiple="true" key="id" label="translated_name">
            </search_select>
            <search_select v-else-if="type=='add_to_client' || type == 'force_update_to_client'" id="value_to_client" :options="JSON.parse($attrs.clients)" :closeOnSelect="false"
                :multiple="false" key="id" label="name">
            </search_select>
            <search_select v-else-if="type=='add_categories'" id="categories_to_value" :options="JSON.parse($attrs.categories)" :closeOnSelect="false"
                :multiple="true" key="id" label="translated_name">
            </search_select>
            <search_select v-else-if="type=='add_locations'" id="locations_to_value" :options="JSON.parse($attrs.locations)" :closeOnSelect="false"
                :multiple="true" key="id" label="translated_name">
            </search_select>
        </div>
        <div>
            <button
                class="px-8 rounded-r-lg bg-primary text-white p-2 border-primary border-t border-b border-r">Submit</button>
        </div>
    </div>
</template>


<script>
export default {
    data() {
        return {
            type: 0,
            value_to_client: 0,
            value_to_event: 0,
            categories_to_value: 0,
            locations_to_value: 0,
        };
    },
    methods: {

    }
};
</script>